// extracted by mini-css-extract-plugin
export default {"skeleton-segmented-control":"Y7xSH5"};